import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import { MwLoadOptionsService } from './../services/utils/load-options.service';
import { MwLoadOptions } from './../models/load-options.model';
import { MwPayloadModel } from './..//models/payload.model';
import { DriverApiModel } from 'app/models/drivers-api.model';

@Injectable()
export class MwDriversApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService,
  ) {}

  private apiEndpoint = '/integration/v1/Companies/{companyId}/Drivers';

  getDrivers(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<DriverApiModel[]>> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<MwPayloadModel<DriverApiModel[]>>(
      `${this.apiEndpoint}${query}`
    );
  }

  createDriver(driver: DriverApiModel): Observable<DriverApiModel> {
    return this.http.authPost<DriverApiModel>(`${this.apiEndpoint}`, {
      body: driver,
    });
  }

  updateDriver(driver: DriverApiModel): Observable<DriverApiModel> {
    return this.http.authPut<DriverApiModel>(`${this.apiEndpoint}`, {
      body: driver,
    });
  }

  deleteDriver(driver: DriverApiModel): Observable<any> {
    return this.http.authDelete(`${this.apiEndpoint}`, {
      body: driver,
    });
  }

  deleteDriversList(drivers: DriverApiModel[]): Observable<any> {
    return forkJoin(
      drivers.map((item) =>
        this.http.authDelete<DriverApiModel[]>(`${this.apiEndpoint}`, {
          body: item,
        })
      )
    );
  }
}
